import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Instagram, Youtube, ExternalLink, FolderOpen, Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { aboutMeContent } from '../data/aboutMe';

const AboutMe = () => {
  const { t } = useTranslation();
  
  const iconMap = {
    linkedin: Linkedin,
    instagram: Instagram,
    youtube: Youtube,
    workana: ExternalLink,
    upwork: ExternalLink,
    drive: FolderOpen,
    mail: Mail
  };

  return (
    <div className="page-about">
      <section className="about-hero">
        <div className="about-hero-container">
          <div className="about-hero-content">
            <div className="about-profile-image">
              <img src={aboutMeContent.profile.image} alt={aboutMeContent.profile.name} />
            </div>
            <div className="about-profile-info">
              <h1 className="about-profile-name">{aboutMeContent.profile.name}</h1>
              <p className="about-profile-title">{aboutMeContent.profile.title}</p>
              <p className="about-profile-tagline">{aboutMeContent.profile.tagline}</p>
              
              <div className="about-social-links">
                {aboutMeContent.socialLinks.map((link, index) => {
                  const Icon = iconMap[link.icon] || ExternalLink;
                  return (
                    <a 
                      key={index}
                      href={link.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="about-social-link"
                      aria-label={link.platform}
                      title={link.platform}
                    >
                      <Icon size={20} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-story">
  <div className="about-container">
    {/* Bloco de Texto Principal */}
    <div className="about-story-full">
      <h2 className="about-section-title">{t('about.myStory')}</h2>
      <p className="about-story-text">{aboutMeContent.story.introduction}</p>
      
      <h3 className="about-subsection-title">{t('about.mission')}</h3>
      <p className="about-story-text">{aboutMeContent.story.mission}</p>
      
      <h3 className="about-subsection-title">{t('about.approach')}</h3>
      <p className="about-story-text">{aboutMeContent.story.approach}</p>
      
      <div className="about-values">
        <h3 className="about-subsection-title">{t('about.coreValues')}</h3>
        <div className="about-values-fullwidth">
          {aboutMeContent.story.values.map((value, index) => (
            <div key={index} className="about-value-card-full">
              <h4 className="about-value-title">{value.title}</h4>
              <p className="about-value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Novo Container para Habilidades e Certificações lado a lado */}
    <div className="about-skills-certs-container">
      <div className="about-skills-card">
        <h3 className="about-sidebar-title">{t('about.keySkills')}</h3>
        <div className="about-skills-grid">
          {aboutMeContent.skills.map((skill, index) => (
            <span key={index} className="about-skill-badge">
              {skill.name}
            </span>
          ))}
        </div>
      </div>

      {aboutMeContent.certifications?.length > 0 && (
        <div className="about-certifications-card">
          <h3 className="about-sidebar-title">{t('about.certifications')}</h3>
          <ul className="about-certifications-list">
            {aboutMeContent.certifications.map((cert, index) => (
              <li key={index} className="about-certification-item">
                <Award size={16} />
                {cert}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>
</section>

      <section className="about-cta">
        <div className="about-cta-container">
          <h2 className="about-cta-title">{t('about.ctaTitle')}</h2>
          <p className="about-cta-subtitle">
            {t('about.ctaSubtitle')}
          </p>
          <div className="about-cta-buttons">
            <Link to="/portfolio" className="btn-secondary btn-large">
              {t('about.viewPortfolio')}
            </Link>
            <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
              {t('about.getInTouch')}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutMe;
